
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class VisDefinitionStateAPI
 * @hideconstructor
 * @classdesc API class that is used for VisDefinition state
 */
define([], () => {
	class VisDefinitionStateAPI {

		/**
		 * @function VisDefinitionStateAPI#getError
		 * @description get the error associated to the vis definition state.
		 * @return {Error} The error object of the state.
		 */
		getError() {}
	}

	return VisDefinitionStateAPI;
});
